import { render, staticRenderFns } from "./skumapping-add.vue?vue&type=template&id=adaaba1c"
import script from "./skumapping-add.vue?vue&type=script&lang=ts"
export * from "./skumapping-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports